import { h } from 'preact';
import Store from 'store/store';
import * as categories from '../categories';
import * as oneTrustCategories from 'utils/gdpr/oneTrust/categories';
import * as queue from '../queue';
import passToIframe, { listenToIframe } from './iframe';
import { accessNested } from 'utils/utils';
import pendingPromise from 'utils/pendingPromise';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from './connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING, PERFORMANCE } from '../constants';

export const displayModal = () => {
	if (typeof window === 'object') {
		const api = window.Optanon || window.OneTrust;
		if (api && typeof api === 'object' && typeof api.ToggleInfoDisplay === 'function') {
			api.ToggleInfoDisplay();
		}
	}
};

const loadPromise = pendingPromise();
export const waitForOneTrust = async () => loadPromise;

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
	queue.drain(allowedCategories);
});

function oneTrustFix() {
	const oneTrustFix = accessNested(Store.get(), 'appData.apis.tracking.oneTrust.oneTrustFix');
	const oneTrustOverlapFix = accessNested(Store.get(), 'appData.apis.tracking.oneTrust.oneTrustOverlapFix');
	if (oneTrustFix && !getCookie('OptanonAlertBoxClosed')) {
		let buttons = document.querySelectorAll('.optanon-white-button-middle, .accept-cookies-button');

		const bindEvent = (el, eventName, eventHandler) => {
			if (!el) {
				return;
			}
			if (el.addEventListener) {
				el.addEventListener(eventName, eventHandler, false);
			} else if (el.attachEvent) {
				el.attachEvent('on' + eventName, eventHandler);
			}
		};

		// ???
		const close = () => {
			let banner = document.getElementById('optanon');
			if (!banner) return;
			banner.style.opacity = 0;
			banner.style.transition = 'opacity .8s';
			setTimeout(() => {
				const bg = document.getElementById('optanon-popup-bg');
				if (bg) {
					bg.style.display = 'none';
					banner.style.opacity = 1;
				}
			}, 800);
		};
		[...buttons].forEach(button => bindEvent(button, 'click', close));


	}
	if (oneTrustFix && !getCookie('OptanonAlertBoxClosed') && oneTrustOverlapFix) {
		setTimeout(() => {
			const pixelConsent = accessNested(Store.get(), 'client.pixelConsent');
			const banner = document.querySelectorAll('.optanon-alert-box-wrapper');
			const bannerDisplay = banner[0] && banner[0].style && banner[0].style.getPropertyValue('display');
			if (pixelConsent && bannerDisplay && bannerDisplay === 'none') {
				const body = document.getElementsByTagName('body');
				body[0].style.transform = 'none';
			}
		}, 800);
	}

}

function getCookie(name) {
	let value = '; ' + document.cookie;
	let parts = value.split('; ' + name + '=');
	if (parts.length == 2) {
		return parts.pop().split(';').shift();
	}
}
if (typeof window !== 'undefined') {
	let isOptatonInitialised = false;
	const existingOptanonWrapper = window.OptanonWrapper;

	listenToIframe();

	// let justRejectedAll = false;
	window.OptanonWrapper = function() {
		if (typeof existingOptanonWrapper === 'function') {
			try {
				existingOptanonWrapper();
			} catch (e) {}
		}

		loadPromise.resolve();

		if (window.dataLayer) {
			window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
		}

		passToIframe();
		oneTrustFix();

		if (!isOptatonInitialised) {
			const activeGroups = window.OptanonActiveGroups;
			oneTrustCategories.set(activeGroups);
			isOptatonInitialised = true;
		}
	};

	window.addEventListener('consent.onetrust', ({ detail }) => oneTrustCategories.set(detail));
	window.addEventListener('OneTrustGroupsUpdated', ({ detail }) => oneTrustCategories.set(detail));
}
